module.exports = __webpack_public_path__ + "assets/img/03-b61d85a6.jpg";